export var DEFAULT_VIRTUAL_CURRENCY_NAME = 'Teal';
export var DEFAULT_REAL_CURRENCY_NAME = 'USD';
